const WatchTrackingAnalyticsFieldName = {
  Cumulative: {
    ActualDurationWatched:
      "Video actual watch duration, including rewatches (seconds)",
    ActualWatchTime:
      "Video actual watch time (including rewatches), adjusted for playback rate (seconds)",
    UniqueDurationWatched: "Video unique watch duration (seconds)",
    UniqueWatchedPercentage: "Video percentage watched (%)",
  },
  UserId: "User ID",
  Video: {
    CarouselIndex: "Video carousel index",
    CarouselTitle: "Video carousel title",
    Length: "Video length (seconds)",
    PositionPercentage: "Video position (%)",
    PositionSeconds: "Video position (seconds)",
    SeekAmountPercentage: "Video seek amount (%)",
    SeekAmountSeconds: "Video seek amount (seconds)",
    SeekFromSeconds: "Video seek from position (seconds)",
    Speed: "Video speed",
    SpeedPrevious: "Video previous speed",
    Status: "Video status",
    Title: "Video title",
    Url: "Video URL",
  },
};

const WatchTrackingAnalyticsEvent = {
  Video: {
    Closed: "Video closed",
    Opened: "Video opened",
    PlaybackPaused: "Video paused",
    PlaybackRateChanged: "Video speed changed",
    PlaybackResumed: "Video resumed",
    PlayedToEnd: "Video played to end",
    Seek: "Video seek",
    Started: "Video started",
  },
};

export { WatchTrackingAnalyticsEvent, WatchTrackingAnalyticsFieldName };
